import { apiGet } from './client';

export function getUsersRating(limit = 10, offset = 0) {
  return apiGet(`/ratings/users?limit=${limit}&offset=${offset}`);
}

export async function getAllUsersRating() {
  const items = [];
  while (true) {
    const page = await getUsersRating(100, items.length);
    items.push(...page);
    if (page.length < 100) return items;
  }
}

export function getTeamsRating(limit = 10, offset = 0, trackLabel = '') {
  const params = new URLSearchParams({
    limit: String(limit),
    offset: String(offset),
  });
  if (trackLabel) {
    params.set('track_label', trackLabel);
  }
  return apiGet(`/ratings/teams?${params.toString()}`);
}
